import {ApplicationRef, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: 'app-simple-list-editable',
  templateUrl: 'app-simple-list-editable.html',
  styleUrls: ['simple-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SimpleListEditableComponent {

  constructor(public app: ApplicationRef, public ref: ChangeDetectorRef) {
  }

  @Input() item;
  @Input() content: ((any) => string);
  @Input() editable = false;
  @Output() editChange: EventEmitter<any> = new EventEmitter();

  m_editing = false;
  // m_icon = 'fa-edit';
  m_value = '';

  public onEdit(changed: boolean) {
    let delay;
    if (this.m_editing) {
      delay = 100;
      // this.m_icon = 'fa-edit';
      if (changed)
        this.editChange.emit({item: this.item, value: this.m_value});
    } else {
      delay = 0;
      if (this.content) {
        this.m_value = this.content(this.item);
      }
      // this.m_icon = 'fa-check';
    }
    this.updateDetection();
    // use small delay so you don't see a skip in data appending
    setTimeout(() => {
      this.m_editing = !this.m_editing;
      this.updateDetection();
    }, delay);
  }

  public updateDetection() {
    this.ref.markForCheck();
  }

  public getContent(item): string {
    if (this.content) {
      return this.content(item);
    } else {
      return item;
    }
  }

}

